import { render, staticRenderFns } from "./rotas.vue?vue&type=template&id=63277cf0&"
import script from "./rotas.vue?vue&type=script&lang=js&"
export * from "./rotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports